  document.addEventListener("DOMContentLoaded", function() {
      setTimeout(function() {
          document.getElementById('fondo-oscuro').style.display = 'block';
          document.getElementById('popup').style.display = 'block';
      }, 20000); // 10000 milisegundos = 10 segundos

      document.getElementById('cerrar-popup').addEventListener('click', function() {
          document.getElementById('fondo-oscuro').style.display = 'none';
          document.getElementById('popup').style.display = 'none';
      });

      document.getElementById('cerrar-popup-x').addEventListener('click', function() {
          document.getElementById('fondo-oscuro').style.display = 'none';
          document.getElementById('popup').style.display = 'none';
      });
  });
